import React from 'react';

import { nanoid } from '@reduxjs/toolkit';

import { bemCssModules } from '@utils';

import style from './Alert.scss';

const cn = bemCssModules(style, 'Alert');

export type TAlert = {
  title?: React.ReactNode;
  content: React.ReactNode;
  buttons?: {
    label: string;
    onClick: (e: React.FormEvent<HTMLButtonElement>) => void;
    icon?: React.ReactNode;
  }[];
};

const Alert: CustomFC<TAlert> = props => {
  const { className, title, content, buttons } = props;

  return (
    <div className={cn(null, [className])}>
      {title && <div className={cn('title')}>{title}</div>}
      <div className={cn('content')}>{content}</div>
      <div className={cn('buttons')}>
        {buttons?.map(({ label, onClick, icon }) => (
          <button key={nanoid()} type="button" className={cn('button', ['link'])} onClick={onClick}>
            {icon && <div className={cn('icon')}>{icon}</div>}
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Alert;
